// extracted by mini-css-extract-plugin
export default {"pageWrap":"ga-z","fullWidth":"ha-z","heading":"ia-z","fullBleed":"ja-z","hidden":"ka-z"};